module.exports = __webpack_public_path__ + "img/header.7fe11475.png";